import * as React from "react";

const { Component } = React;

import { createOrSaveIntegration } from "../IntegrationStore";
import { alert } from "../../general/alertStore.js";
import IntegrationTrigger from "../IntegrationTrigger";
import axios from "../../general/HttpClient";
import { GetContext, UnsubscribeContext } from "../../general/ApplicationContext";

import { ScadsysProps, ScadsysUserState, ScadsysIntegration } from "./ScadsysStore";
import { Input } from "reactstrap";

let contextSubscriptionId = "";

export default class ImportScadsysUsers extends Component<ScadsysProps, ScadsysUserState> {
    constructor(props) {
        super(props);

        this.state = {
            profiles: [],
            users: [],
            selectedProfile: new ScadsysIntegration(),
            selectedProfileId: "",
            totals: {
                users: 0,
            },
            syncResult: null,
        };
    }

    saveProfile = () => {
        if (this.state.selectedProfile.name) {
            this.setState(
                (prevState) => {
                    prevState.selectedProfile.integrationDirection = 0; //In
                    prevState.selectedProfile.integrationType = 1; //ScadsysUsers
                    prevState.selectedProfile.organizationId = this.props.organization;

                    return prevState;
                },
                () => {
                    createOrSaveIntegration(this.state.selectedProfile).then(() => {
                        this.getProfiles();
                    });
                }
            );
        }
    };

    loadUsers = () => {
        axios.post(`/api/Integrations/${this.state.selectedProfileId}/GetScadsysUsers`, this.state.selectedProfile.config).then((response) => {
            this.setState({
                totals: {
                    users: response.data.totalUsers,
                },
                users: response.data.users.map((user) => {
                    return user;
                }),
            });
        });
    };

    importUsers = () => {
        axios
            .post(`/api/Integrations/${this.state.selectedProfileId}/ImportUsersFromScadsys`, this.state.selectedProfile.config)
            .then((response) => {
                alert({
                    type: "alert-success",
                    text: `${response.data.usersProcessed} users processed successfully`,
                });
                this.setState({ syncResult: response.data });
            })
            .catch((response) => {
                this.setState({ syncResult: response.data });
            });
    };

    componentDidMount() {
        contextSubscriptionId = GetContext((context) => {
            this.getProfiles();
        });
    }

    componentWillUnmount() {
        UnsubscribeContext(contextSubscriptionId);
    }

    getProfiles = () => {
        axios
            .get(`/api/Integrations/Types/1?organizationId=${this.props.organization}`) //Scadsys
            .then((response) => {
                this.setState({ profiles: response.data.filter(i=>i.integrationDirection == 0), selectedProfile: new ScadsysIntegration(), selectedProfileId: "" });
            });
    };

    handleProfileChange = (e) => {
        let id = e.target.value;
        this.setState((prevState) => ({ selectedProfileId: id, selectedProfile: new ScadsysIntegration(prevState.profiles.filter((profile) => profile.integrationId == id)[0]) }));
    };

    handleNameChange = (e) => {
        let name = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.name = name;
            return prevState;
        });
    };

    handlePriorityChange = (e) => {
        let priority = e.target.valueAsNumber;
        this.setState((prevState) => {
            prevState.selectedProfile.priority = priority;
            return prevState;
        });
    };

    handleSchoolIdChange = (e) => {
        let schoolId = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.schoolId = schoolId;
            return prevState;
        });
    };

    handleScadsysUrlChange = (e) => {
        let url = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.url = url;
            return prevState;
        });
    };

    handlePageSizeChange = (e) => {
        let pageSize = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.pageSize = pageSize;
            return prevState;
        });
    };

    handleDomainChange = (e) => {
        let domain = e.target.value;
        this.setState((prevState) => {
            prevState.selectedProfile.config.domain = domain;
            return prevState;
        });
    };

    render() {
        return (
            <div>
                <h3>Scadsys Users Import</h3>

                <div className="row">
                    <div className="col-12">
                        <div className="form-group row">
                            <label className="col-xs-12 col-md-3 col-form-label">Profile</label>
                            <div className="col-xs-12 col-md-9 pl-0">
                                <Input type="select" onChange={this.handleProfileChange} value={this.state.selectedProfileId}>
                                    <option>Please Select</option>
                                    {this.state.profiles.map((profile) => (
                                        <option key={profile.integrationId} value={profile.integrationId}>
                                            {profile.name}
                                        </option>
                                    ))}
                                </Input>
                            </div>
                        </div>
                    </div>
                    {this.state.selectedProfileId && (
                        <div className="col-12">
                            <IntegrationTrigger integration={this.state.selectedProfile}></IntegrationTrigger>
                        </div>
                    )}
                    <div className="col-xs-12 col-md-6">
                        <div className="form-group row">
                            <label className="col-xs-12 col-md-3 col-form-label">Profile Name</label>
                            <div className="col-xs-12 col-md-9 pl-0">
                                <input type="text" className="form-control" value={this.state.selectedProfile.name} onChange={this.handleNameChange} />
                            </div>
                        </div>
                    </div>
                    {this.state.selectedProfileId && (
                        <div className="col-xs-12 col-md-6">
                            <div className="form-group row">
                                <label className="col-xs-12 col-md-3 col-form-label">Priority (lower first)</label>
                                <div className="col-xs-12 col-md-9 pl-0">
                                    <input type="number" className="form-control" value={this.state.selectedProfile.priority} onChange={this.handlePriorityChange} />
                                </div>
                            </div>
                        </div>
                    )}
                    {!this.state.selectedProfileId && (
                        <div className="col-xs-12 col-md-6">
                            <div className="d-flex align-items-end flex-column pt-4">
                                <div className="mt-auto">
                                    <button className="btn btn-success me-1" type="button" onClick={this.saveProfile}>
                                        Create Profile
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                {this.state.selectedProfileId && (
                    <div>
                        <div className="row">
                            <div className="col-xs-12 col-md-6">
                                <div className="form-group row">
                                    <label className="col-xs-12 col-md-3 col-form-label">School ID</label>
                                    <div className="col-xs-12 col-md-9 pl-0">
                                        <input type="text" className="form-control" value={this.state.selectedProfile.config.schoolId} onChange={this.handleSchoolIdChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6">
                                <div className="form-group row">
                                    <label className="col-xs-12 col-md-3 col-form-label">Scadsys URL</label>
                                    <div className="col-xs-12 col-md-9 pl-0">
                                        <input type="text" className="form-control" value={this.state.selectedProfile.config.url} onChange={this.handleScadsysUrlChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6">
                                <div className="form-group row">
                                    <label className="col-xs-12 col-md-3 col-form-label">Domain</label>
                                    <div className="col-xs-12 col-md-9 pl-0">
                                        <input type="text" className="form-control" value={this.state.selectedProfile.config.domain} onChange={this.handleDomainChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6">
                                <div className="form-group row">
                                    <label className="col-xs-12 col-md-3 col-form-label">Page Size</label>
                                    <div className="col-xs-12 col-md-9 pl-0">
                                        <input type="number" className="form-control" value={this.state.selectedProfile.config.pageSize} onChange={this.handlePageSizeChange} />
                                        <span className="float-left text-muted">Make this 0 for all, or specify a number to improve performance on large data sets</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xs-12 col-md-6">
                                <div className="d-flex align-items-end flex-column pt-4">
                                    <div className="mt-auto">
                                        <button className="btn btn-success me-1" type="button" onClick={this.saveProfile}>
                                            Save Profile
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <div className="d-flex align-items-end flex-column pt-4">
                                    <div className="mt-auto">
                                        <button className="btn btn-success me-1" type="button" onClick={this.loadUsers}>
                                            Load
                                        </button>
                                        <button className="btn btn-primary" type="button" onClick={this.importUsers}>
                                            Import
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                {this.state.syncResult && (
                                    <div>
                                        <a href={`/hangfire/jobs/details/${this.state.syncResult}`}>Background Job Created</a>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <table className="table w-100">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "20%" }}>User Number</th>
                                            <th style={{ width: "40%" }}>Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th>{this.state.totals.users} Users</th>
                                            <th></th>
                                        </tr>
                                        {this.state.users.map((user, i) => (
                                            <tr key={i}>
                                                <td>{user.sourceID}</td>
                                                <td>{user.fullName}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
